import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useResendVerificationUser } from '@/lib/api/use-resend-verification-user';
import { NstButton, NstIcon, NstText } from '@nstechhub/nsds-react';

interface ErrorToResendEmailProps {
  email: string;
  userId: string;
}

export const ErrorToResendEmail = ({
  email,
  userId,
}: ErrorToResendEmailProps) => {
  const resendVerificationUserMutation = useResendVerificationUser();
  return (
    <div className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4 gap-6'>
      <Card className='w-full max-w-xl'>
        <CardHeader className='text-center space-y-4'>
          <div className='mx-auto w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center'>
            {resendVerificationUserMutation.isSuccess ? (
              <NstIcon name='circle-check-big' size='lg' color='success' />
            ) : (
              <NstIcon name='circle-x' size='lg' color='danger' />
            )}
          </div>
          <div className='space-y-2'>
            <CardTitle className='text-2xl font-bold text-gray-900'>
              {resendVerificationUserMutation.isSuccess
                ? `Foi enviado um novo link de ativação para o email ${email}. Verifique sua caixa de entrada!`
                : 'Não foi possível confirmar sua conta!'}
            </CardTitle>
          </div>
        </CardHeader>

        <CardContent className='space-y-6'>
          {!resendVerificationUserMutation.isSuccess && (
            <div className='text-center space-y-4'>
              <div className='flex items-center justify-center gap-2'>
                <NstIcon name='circle-alert' size='xs' />
                <NstText level='body'>
                  Token inválido, expirado ou já utilizado
                </NstText>
              </div>
            </div>
          )}

          <div className='space-y-3 flex flex-col items-center justify-center'>
            <NstButton
              variant='primary'
              size='lg'
              onClick={() => resendVerificationUserMutation.mutate(userId)}
              disabled={resendVerificationUserMutation.isPending}
              loading={resendVerificationUserMutation.isPending}
            >
              {resendVerificationUserMutation.isPending
                ? 'Enviando'
                : 'Enviar novo link de ativação'}
            </NstButton>

            {resendVerificationUserMutation.isSuccess && (
              <div className='flex items-center gap-2'>
                <NstIcon name='circle-check' size='xs' color='success' />
                <NstText level='caption'>
                  {`Um novo link foi enviado para ${email}.`}
                </NstText>
              </div>
            )}
            {resendVerificationUserMutation.isError && (
              <div className='flex items-center gap-2'>
                <NstIcon name='circle-alert' size='xs' color='danger' />
                <NstText level='caption'>
                  Erro ao enviar novo link de ativação. Contate um
                  administrador!
                </NstText>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
